import React from 'react'
import { useSelector } from 'react-redux'
import _get from 'lodash/get'
import { H2 } from '../../Heading/index'
import { get as getConfig } from '../../../config/index'
import { selectStaticTextByKey } from '../../../services/static-text/selectors'
import NotificationSettings from './NotificationSettings'
import DisplaySettings from './DisplaySettings'
import LanguageSettings from './LanguageSettings'
import HiddenContentSettings from './HiddenContentSettings'
import RemovedRowsSettings from './RemovedRowsSettings'
import FollowingSettings from './FollowingSettings'
import CommunicationSettings from './CommunicationSettions'

const config = getConfig()
const manageEmailCommunication = !!_get(config, ['features', 'userAccount', 'manageEmailCommunication'])

const MyAccountSettingsV2 = () => {
  const staticText = useSelector(selectStaticTextByKey('myAccountSettingsV2'))

  return (
    <div className="my-account-settings-V2 content-preferences">
      <H2>
        {staticText.get('settingsAndPreferences', '')}
      </H2>
      <NotificationSettings />
      <DisplaySettings />
      <LanguageSettings />
      {
        manageEmailCommunication
          ? <CommunicationSettings />
          : null
      }
      <FollowingSettings />
      <HiddenContentSettings />
      <RemovedRowsSettings />
    </div>
  )
}

export default MyAccountSettingsV2
